const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupeeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 9.49316,
    cy: 9,
    r: 7.5,
    fill: "url(#paint0_linear_1610_15106)",
    stroke: "#BBA387",
    style: {
      stroke: "#BBA387",
      stroke: "color(display-p3 0.7334 0.6382 0.5312)",
      strokeOpacity: 1
    },
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7465 8.54941H10.773C10.6823 9.30016 10.2203 9.73741 9.13954 9.83641L10.9958 12.0557H9.69229L7.89379 9.86116V9.35791H8.35579C9.11479 9.35791 9.47779 9.10216 9.56029 8.54941H7.89379V8.01316H9.56854C9.49429 7.43566 9.13954 7.22116 8.36404 7.22116H7.89379V6.69316H11.7465V7.22116H10.4018C10.6163 7.41091 10.74 7.67491 10.7813 8.01316H11.7465V8.54941Z",
    fill: "#2B231A",
    style: {
      fill: "#2B231A",
      fill: "color(display-p3 0.1686 0.1373 0.1020)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1610_15106",
    x1: 9.49316,
    y1: 0,
    x2: 9.49316,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80684E",
    style: {
      stopColor: "#80684E",
      stopColor: "color(display-p3 0.5017 0.4089 0.3045)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECD6",
    style: {
      stopColor: "#FFECD6",
      stopColor: "color(display-p3 1.0000 0.9237 0.8379)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeIcon);
export default __webpack_public_path__ + "static/media/RupeeIcon.281798717b05250b70945053a7751601.svg";
export { ForwardRef as ReactComponent };